'use client';

import { useTranslations } from 'next-intl';
import { NavbarMenuItem } from '@heroui/react';
import { Links } from '@/app/utils/links';

type NavbarMenuItemsProps = {
  links: Links;
};

export default function NavbarMenuItems({ links }: NavbarMenuItemsProps) {
  const t = useTranslations('burgerMenu');
  const tLinks = useTranslations('links');

  const menuItems = [
    { label: t('priceComparison'), link: links.root },
    { label: t('greens'), link: links.greens },
    { label: t('priceCap'), link: links.strompreisbremse },
    { label: t('faq'), link: links.faq },
    { label: t('contact'), link: tLinks('support') },
  ];

  const availableMenuItems = menuItems.filter((item) => item.link != '');

  return (
    <div className="mt-[100px]">
      {availableMenuItems.map((item, index) => (
        <NavbarMenuItem className="pb-8" key={item.label}>
          <a href={item.link}>
            <p
              className={`${
                index == 0
                  ? 'text-[var(--color-action-primary)] underline'
                  : 'text-white'
              } font-heading leading-8 text-2xl`}
            >
              {item.label}
            </p>
          </a>
        </NavbarMenuItem>
      ))}
    </div>
  );
}
